// let  targetNode = document.querySelector('html')
//   function setCookie(cName, cValue, expDays) {
//     let date = new Date();
//     cValue = encodeURIComponent(cValue)
//     date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
//     const expires = "expires=" + date.toUTCString();
//     document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
// }
// const callback = function(mutationsList) {
//     mutationsList.forEach(function(mutation) {
//     mutation.addedNodes.forEach(function(added_node) { setCookie('discount_code', '', 1); });
//     });
// };
// const config = { attributes: true, childList: true, subtree: true };const observer = new MutationObserver(callback);observer.observe(targetNode, config); 

(function () {
  if (window.__discountObserverInitialized) return;
  window.__discountObserverInitialized = true;

  let targetNode = document.querySelector('html');

  function setCookie(cName, cValue, expDays) {
    let date = new Date();
    cValue = encodeURIComponent(cValue);
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
  }

  const callback = function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      mutation.addedNodes.forEach(function () {
        setCookie('discount_code', '', 1);
      });
    });
  };

  const config = { attributes: true, childList: true, subtree: true };

  //  store observer on window to avoid redeclaration
  window.__discountObserver = new MutationObserver(callback);
  window.__discountObserver.observe(targetNode, config);

})();
